<template>
    <div class="d-flex flex-column mb-2 border p-2 q-c">
        <div class="d-flex justify-content-between gap-3 mb-2">
            <input type="text" class="form-control w-100" :id="'autoComplete-' + uuid" />
            <i class="bi bi-trash hoverable-icon text-danger w-auto height-100" @click="emits('removeRelated', { uuid: uuid, selectedQs: selection })"></i>
        </div>
        <select v-if="selection && choices.length" class="form-select" multiple aria-label="Select choices after which this question should appear." v-model="selected_choices">
            <option disabled>Select choices after which this question should appear.</option>
            <option v-for="(choice, index) in choices" :value="choice.id">{{ choice.text }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import autoComplete from "@tarekraafat/autocomplete.js";

const props = defineProps({
    uuid: String,
    related_questions: Array,
    question: Object,
    selected_choices: Array
});

const emits = defineEmits(['relatedQuestionSelected', 'selectedChoicesUpdated', 'removeRelated']);

const choices = ref([]);
const selection = ref(null);
const selected_choices = ref(props.selected_choices ? props.selected_choices : []);
const autoCompleteJS = ref(null);

watch(selected_choices, (val) => {
    if (selection) {
        let correct_choices = choices.value.filter((choice) => { return selected_choices.value.includes(choice.id); });
        emits('selectedChoicesUpdated', { uuid: props.uuid, selectedQs: selection, correct_choices: correct_choices });
    }
});

const initUpdateComplete = ref(false);
watch(() => props.related_questions, (val) => {
    if (autoCompleteJS.value && props.related_questions && props.related_questions.length && props.question && props.question.description && !initUpdateComplete.value) {
        initUpdateComplete.value = true;
        initUpdateAutoCompleteSelection();
    }
});

const initUpdateAutoCompleteSelection = () => {
    let description = props.question.description.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
    autoCompleteJS.value.input.value = description;
    autoCompleteJS.value.input.setAttribute('disabled', 'disabled');
    autoCompleteJS.value.input.setAttribute('readonly', 'readonly');
    selection.value = props.question;
    choices.value = selection.value.choices;
    selected_choices.value = props.selected_choices;
}

onMounted(() => {
    autoCompleteJS.value = new autoComplete({
        selector: `#autoComplete-${props.uuid}`,
        placeHolder: "Search for Related Question",
        data: {
            src: props.related_questions,
            keys: ["description"]
        },
        resultItem: {
            highlight: false,
        }
    });

    autoCompleteJS.value.input.addEventListener("selection", function (event) {
        const feedback = event.detail;
        autoCompleteJS.value.input.blur();
        selection.value = feedback.selection.value;
        autoCompleteJS.value.input.value = selection.value.description.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
        choices.value = selection.value.choices;

        emits('relatedQuestionSelected', { uuid: props.uuid, selectedQs: selection });
    });

})
</script>

<style lang="scss">
.autoComplete_wrapper {
    width: 100%;

    input {
        color: inherit;
    }
}

.q-c {
    background-color: #f4f4f4;
    ;
}
</style>